import * as d3 from "./assets/d3";
import { event, select } from "d3-selection";
import * as React from "react";
export default class Brush extends React.PureComponent {
    constructor() {
        super(...arguments);
        this.brushSvg = null;
        this.brush = null;
        this.configBrush = () => {
            const brushed = () => {
                const { xScale, yScale, y2Scale } = this.props;
                const { margins } = this.props;
                const source = event.sourceEvent;
                if ((source.type === "mouseup" || source.type === "touchend") &&
                    event.selection) {
                    const selection = event.selection;
                    const newXScaleDomain = [
                        xScale.invert(selection[0][0] + margins.left),
                        xScale.invert(selection[1][0] + margins.left),
                    ];
                    const newYScaleDomain = [
                        yScale.invert(selection[1][1] + margins.top),
                        yScale.invert(selection[0][1] + margins.top),
                    ];
                    const newY2ScaleDomain = y2Scale
                        ? [
                            y2Scale.invert(selection[1][1] + margins.top),
                            y2Scale.invert(selection[0][1] + margins.top),
                        ]
                        : null;
                    this.props.onScaleChange(newXScaleDomain, newYScaleDomain, newY2ScaleDomain);
                    const svg = select(this.brushSvg);
                    svg.select(".brush").call(this.brush.move, null);
                }
                else if (source.type === "mouseup" || source.type === "touchend") {
                    this.props.onScaleChange(null, null, null);
                }
            };
            const brush = d3.brush().on("end", () => {
                brushed();
            });
            this.brush = brush;
        };
    }
    componentDidMount() {
        this.configBrush();
        const svg = select(this.brushSvg);
        const context = svg.select(".brusher").append("g").attr("class", "brush");
        context.call(this.brush);
        context.on("mousemove", this.props.onMousemove);
    }
    componentDidUpdate() {
        this.configBrush();
        const svg = select(this.brushSvg);
        svg.selectAll(".brush").remove();
        const context = svg.select(".brusher").append("g").attr("class", "brush");
        context.call(this.brush);
        context.on("mousemove", this.props.onMousemove);
    }
    componentWillUnmount() {
        const svg = select(this.brushSvg);
        svg.selectAll(".brush").remove();
    }
    render() {
        const { width, height, margins } = this.props;
        return (React.createElement("svg", { width: width - margins.right - margins.left > 0
                ? width - margins.right - margins.left
                : 0, height: height - margins.bottom - margins.top > 0
                ? height - margins.bottom - margins.top
                : 0, style: { top: `${margins.top}px`, left: `${margins.left}px` }, xmlns: "http://www.w3.org/2000/svg", className: "brushSvg", ref: (ref) => {
                this.brushSvg = ref;
            } },
            React.createElement("g", { className: "brusher" })));
    }
}
//# sourceMappingURL=Brush.js.map